import { hbs } from 'ember-cli-htmlbars';
export default hbs("<TruncateWithTooltip\n  data-test-truncate-with-tooltip\n  @message={{this.valueOrSlashDisplay}}\n>\n  {{this.valueOrSlashDisplay}}\n</TruncateWithTooltip>")